import { render, staticRenderFns } from "./clientMitCallback.vue?vue&type=template&id=948413d2&scoped=true"
import script from "./clientMitCallback.vue?vue&type=script&lang=js"
export * from "./clientMitCallback.vue?vue&type=script&lang=js"
import style0 from "./clientMitCallback.vue?vue&type=style&index=0&id=948413d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948413d2",
  null
  
)

export default component.exports